import { Checkbox } from '@bblabs/module-library/molecules';
import React, { useEffect, useState } from 'react';

import './Settings.scss';
import { getSettingsService } from '../services/SettingsService';
import { User } from '../models/User';
import { environment } from '../../environment';
import { userService } from '../services/UserService';
import { getAppVersion } from '../../lib/version';
import { getModes, isConfiguredForAutoTracking, isNativeSend, trackByDefault } from '../lib/host';
import { AutoTrackingGlyph } from './AutoTrackingGlyph';

export function Settings() {
  const settings = getSettingsService('bombbomb');
  const user = settings.get('user') as User;
  const [version, setVersion] = useState('');
  const [trackAll, setTrackAll] = useState(settings.get('trackAll') ?? trackByDefault());
  const [filterTracking, setFilterTracking] = useState(settings.get('filterTracking') ?? true);

  useEffect(() => {
    async function getVersion() {
      const result = await getAppVersion();
      setVersion(result);
    }
    getVersion();
  }, []);

  const renderModes = () => {
    return getModes().map((mode) => <li key={mode}>{mode}</li>);
  };

  return (
    <div className="settings">
      <header>
        <h1>Settings</h1>
      </header>

      <div className="option user">
        <div className="label">Signed In As</div>
        {user && <div className="account">{user.get('userName')}</div>}
        <button onClick={userService.onLogoutClick} onKeyDown={userService.onLogoutClick} className="logout">
          Sign out
        </button>
      </div>

      <hr />
      {isNativeSend() && isConfiguredForAutoTracking() && (
        <div className="option auto-tracking">
          <label>
            <span>Auto-Tracking</span>
            <AutoTrackingGlyph displayHoverInfo={false} />
          </label>
          <p className="help">Auto-tracking is enabled. Only emails with BombBomb videos will be tracked.</p>
        </div>
      )}

      {isNativeSend() && !isConfiguredForAutoTracking() && (
        <div className="option tracking">
          <label htmlFor="tracking">
            <span>Enable All Tracking</span>
            <Checkbox
              name="tracking"
              type="toggle"
              defaultChecked={trackAll}
              onChange={(trackEmails: boolean) => {
                setTrackAll(trackEmails);
                settings.set('trackAll', trackEmails, true);
              }}
            />
          </label>
          <p className="help">Enable tracking with BombBomb for all emails sent from Outlook.</p>
        </div>
      )}

      <div className="option filter">
        <label htmlFor="filter">
          <span>Filter Tracking by Selected Email</span>
          <Checkbox
            name="filter"
            type="toggle"
            defaultChecked={filterTracking}
            onChange={(filterLivefire: boolean) => {
              setFilterTracking(filterLivefire);
              settings.set('filterTracking', filterLivefire, true);
            }}
          />
        </label>
        <p className="help">See tracking events for only selected emails in Outlook read-only view.</p>
      </div>

      <hr />
      <div className="option">
        <p className="help">
          Version {version} {isNativeSend() ? ' - Native' : ''}
        </p>
        {environment !== 'prod' && <p className="modes">Modes: {renderModes()}</p>}
      </div>
    </div>
  );
}
